// bd-deepcontext-b4zw — the TLD tag-input rules, previously duplicated inline in
// both the create and the edit form's onKeyDown/onBlur handlers.

/** Trim, lowercase and strip a leading dot: "  .SK " -> "sk". */
export const normalizeTld = (raw: string): string =>
  raw.trim().toLowerCase().replace(/^\./, "");

/**
 * Append a normalized TLD. Blank and duplicate values are no-ops and return the
 * SAME array reference, so callers can skip a needless state update.
 */
export const addTld = (list: string[], raw: string): string[] => {
  const value = normalizeTld(raw);
  if (!value || list.includes(value)) return list;
  return [...list, value];
};

export const removeTldAt = (list: string[], index: number): string[] =>
  list.filter((_, i) => i !== index);

export const dropLastTld = (list: string[]): string[] => list.slice(0, -1);
